import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListWishlistComponent } from './components/list-wishlist/list-wishlist.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [ListWishlistComponent],
  imports: [CommonModule, SharedModule],
})
export class WishlistModule {}
